let data = {
  manage: {
    _comment: "所有菜单列表",
    list: [
      {
        title: "职能",
        icon: require("../assets/menu-icon/func.svg"),
        show: true,
        menu: [
          {
            menuName: "运维管理",
            menuUrl: "homeOperation",
            code: "cloud_resource_statistics",
            show: true
          },
          {
            menuName: "混合云资源概览",
            menuUrl: "cloudResourceGeneral",
            code: "cloud_resource_statistics_mix",
            show: true
          },
          {
            menuName: "招商云资源概览",
            menuUrl: "portalOpenstack",
            code: "cloud_resource_statistics",
            show: true
          }
        ]
      },
      {
        title: "计算",
        icon: require("../assets/menu-icon/computed.svg"),
        show: true,
        menu: [
          {
            menuName: "云主机 ECS",
            menuUrl: "ecsManage",
            code: "instance.create",
            show: true
          },
          {
            menuName: "云主机镜像",
            menuUrl: "publicImage",
            code: "image.admin",
            show: true
          },
          {
            menuName: "云主机快照",
            menuUrl: "ecsSnapshot",
            code: "image.snapshot.admin",
            show: true
          },
          {
            menuName: "云裸机 BMS",
            menuUrl: "bmsManage",
            code: "phyhosts",
            show: true
          },
          {
            menuName: "专有宿主机 CDH",
            menuUrl: "cdhManage",
            code: "ddhosts",
            show: true
          },
          {
            menuName: "部署单元",
            menuUrl: "deployUnits",
            code: "deploy.unit",
            show: true
          },
          {
            menuName: "计算资源回收",
            menuUrl: "ecsRecycle",
            code: "instance.create",
            show: true
          }
        ]
      },
      {
        title: "存储",
        icon: require("../assets/menu-icon/lightning-new.svg"),
        show: true,
        menu: [
          {
            menuName: "云硬盘 CBS",
            menuUrl: "volumeManage",
            code: "admin.storage.ebss",
            show: true
          },
          {
            menuName: "云硬盘快照",
            menuUrl: "snapshot",
            code: "storage.ebs.snapshots.admin",
            childMenu: []
          },
          {
            menuName: "文件存储 NAS",
            menuUrl: "nasManage",
            code: "storage.efss",
            show: true
          },
          {
            menuName: "对象存储 OSS",
            menuUrl: "ossBuckets",
            code: "storage.oss.buckets",
            show: true
          },
          {
            menuName: "块存储SAN",
            menuUrl: "sanManage",
            code: "storage.sans",
            show: true
          },
          {
            menuName: "共享云盘",
            menuUrl: "sharedDiskManage",
            code: "storage.shared_disk",
            show: true
          },
          {
            menuName: "FTP 存储网关",
            menuUrl: "ftpServer",
            code: "storage.ftp_server",
            show: true
          }
        ]
      },
      {
        title: "网络",
        icon: require("../assets/menu-icon/cycle-new.svg"),
        show: true,
        menu: [
          {
            menuName: "专有网络 VPC",
            menuUrl: "vpc",
            code: "network.vpcs",
            show: true
          },
          {
            menuName: "子网",
            menuUrl: "subnet",
            code: "network.subnets",
            show: true
          },
          {
            menuName: "VIP",
            menuUrl: "vip",
            code: "network.vips",
            show: true
          },
          {
            menuName: "多域云解析 DNS",
            menuUrl: "dns",
            code: "v2.dnss",
            show: true
          },
          {
            menuName: "防火墙 FW",
            menuUrl: "firewallManage",
            code: "firewall.orders",
            show: true
          },
          {
            menuName: "负载均衡 SLB",
            menuUrl: "balanceLoad",
            code: "v2.load_balances",
            show: true
          },
          {
            menuName: "EIP",
            menuUrl: "eipManage",
            code: "allocate.eips",
            show: true
          },
          {
            menuName: "共享带宽",
            menuUrl: "shareBand",
            code: "network.shared_bandwidth",
            childMenu: []
          },
          {
            menuName: "NAT网关",
            menuUrl: "natManage",
            code: "nat_gateways",
            show: true
          },
          {
            menuName: "CDN",
            menuUrl: "cdnManage",
            code: "cdn",
            show: true
          },
          {
            menuName: "HTTPDNS",
            menuUrl: "httpDns",
            code: "network.http_dns_domain",
            show: true
          }
        ]
      },
      {
        title: "数据库",
        icon: require("../assets/menu-icon/db-new.svg"),
        show: true,
        menu: [
          {
            menuName: "云数据库 RDS",
            menuUrl: "database",
            code: "dbinstance.create",
            show: true
          },
          {
            menuName: "云数据库 Redis",
            menuUrl: "cacheDatabase",
            code: "dbinstance.create",
            childMenu: []
          },
          {
            menuName: "云数据库 MongoDB",
            menuUrl: "documentDatabase",
            code: "dbinstance.create",
            childMenu: []
          },
          // {
          //   menuName: '数据迁移 DTS',
          //   menuUrl: 'dtcManage',
          //   code:'dts.dbmigrations',
          //   show:true
          // },
          // {
          //   menuName: '数据传输 DTS',
          //   menuUrl: 'dtsManage',
          //   code:'dts.synchronization.create',
          //   show:true
          // },
          {
            menuName: "数据库回收站",
            menuUrl: "dbRecycleBin",
            code: "recylebin.create",
            show: true
          },
          {
            menuName: "数据管理DMS",
            menuUrl: "dmsLogin",
            code: "dms/v1/workspaces/connections",
            childMenu: []
          }
        ]
      },
      {
        title: "云备份",
        icon: require("../assets/menu-icon/backup.svg"),
        show: true,
        menu: [
          {
            menuName: "ECS备份",
            menuUrl: "ecsBackupStrategy",
            code: "ecs.backup.services",
            show: true
          },
          {
            menuName: "MySQL备份",
            menuUrl: "mysqlBackupStrategy",
            code: "dbinstance.backup_policies.all",
            show: true
          },
          {
            menuName: "NAS备份",
            menuUrl: "nasBackupStrategy",
            code: "hcbackup.nas.records", // 待修改
            show: true
          },
          {
            menuName: "Oracle备份",
            menuUrl: "oracleInstance",
            code: "oracle_backup/v1/storage/policys", // 待修改
            show: true
          }
        ]
      },
      {
        title: "云迁移",
        icon: require("../assets/menu-icon/cloudmove.svg"),
        show: true,
        menu: [
          {
            menuName: "主机迁移",
            menuUrl: "cloudMoveInstance",
            code: "cloud_migrate.instances",
            show: true
          },
          {
            menuName: "文件迁移",
            menuUrl: "cloudMoveFile",
            code: "cloud_migrate.files",
            show: true
          },
          {
            menuName: "数据迁移 DTS",
            menuUrl: "dtcManage",
            code: "dts.dbmigrations",
            show: true
          },
          {
            menuName: "数据传输 DTS",
            menuUrl: "dtsManage",
            code: "dts.synchronization.create",
            show: true
          }
        ]
      },
      {
        title: "安全",
        icon: require("../assets/menu-icon/safe.svg"),
        show: true,
        menu: [
          {
            menuName: "堡垒机 TS",
            menuUrl: "fortproperty",
            code: "instance.create",
            show: true
          },
          {
            menuName: "证书服务",
            menuUrl: "certificate",
            code: "cdn.certs",
            show: true
          },
          {
            menuName: "SSL证书",
            menuUrl: "SSLCertificate",
            code: "cert.record",
            childMenu: []
          }
        ]
      },
      {
        title: "服务",
        icon: require("../assets/menu-icon/service.svg"),
        show: true,
        menu: [
          {
            menuName: "办公服务",
            menuUrl: "officeServiceManage",
            code: "create.opsmarket",
            show: true
          },
          {
            menuName: "运营服务",
            menuUrl: "operationServiceManage",
            code: "create.opsmarket",
            show: true
          },
          {
            menuName: "安全服务",
            menuUrl: "safeServiceManage",
            code: "create.opsmarket",
            show: true
          }
        ]
      },
      {
        title: "容量平台",
        icon: require("../assets/menu-icon/capacity-platform.svg"),
        show: true,
        menu: [
          {
            menuName: "主机视图",
            menuUrl: "projectView",
            // menuUrl: 'clusterView',
            code: "zone.flavor",
            show: true
          },
          {
            menuName: "数据库视图",
            menuUrl: "dbProjectView",
            // menuUrl: 'dbClusterView',
            code: "dbinstance.manage.dbspecs",
            show: true
          },
          {
            menuName: "存储视图",
            menuUrl: "memoryProjectView",
            code: "ebs.data.disk.type",
            show: true
          },
          {
            menuName: "成本优化分析",
            menuUrl: "billCostSeo",
            // menuUrl: 'dbClusterView',
            code: "cost.optimization.summary",
            show: true
          }
        ]
      },
      {
        title: "云管理",
        icon: require("../assets/menu-icon/area-manage.svg"),
        show: true,
        menu: [
          {
            menuName: "云主机管理",
            menuUrl: "ecsAdminManage",
            code: "instance.create",
            show: true
          },
          {
            menuName: "云账号管理",
            menuUrl: "cloudAccountManage",
            code: "public_cloud.account",
            show: true
          },
          {
            menuName: "标签管理",
            menuUrl: "tagManage",
            code: "tagsets",
            show: true
          },
          {
            menuName: "项目管理",
            menuUrl: "projectManage",
            code: "auth.project",
            show: true
          },
          {
            menuName: "服务目录",
            menuUrl: "serviceIndex",
            code: "fitportal.service-catalogs",
            show: true
          },
          {
            menuName: "目录设置",
            menuUrl: "serviceSetting",
            code: "fitportal.service-catalogs",
            show: true
          }
        ]
      },
      // {
      //   title: '资源编排',
      //   icon: require('../assets/menu-icon/resource-edit.svg'),
      //   show:true,
      //   menu: [
      //     {
      //       menuName: '可视化编辑器',
      //       menuUrl: 'visualEditor',
      //       code: 'fitportal.visuallayout.templates',
      //       show:true
      //     },
      //     {
      //       menuName: '模板管理',
      //       menuUrl: 'visualTemplateManage',
      //       code: 'fitportal.visuallayout.templates',
      //       show:true
      //     },
      //     {
      //       menuName: '资源栈管理',
      //       menuUrl: 'visualResourceManage',
      //       code: 'fitportal.visuallayout.templates',
      //       show:true
      //     },
      //     {
      //       menuName: '资源配置',
      //       menuUrl: 'visualResourceConfig',
      //       code:'fitportal.visuallayout.templates',
      //       show:true
      //     }
      //   ]
      // },
      {
        title: "物联网平台",
        icon: require("../assets/menu-icon/dmp.svg"),
        show: true,
        platform: "iot",
        menu: [
          {
            menuName: "物联网平台",
            menuUrl: "dmp",
            code: "iotclouds",
            show: true
          }
        ]
      },
      {
        title: "边缘管理平台",
        icon: require("../assets/menu-icon/eciot.svg"),
        show: true,
        platform: "iot",
        menu: [
          {
            menuName: "边缘管理平台",
            menuUrl: "newEciot",
            code: "iotclouds",
            show: true
          }
        ]
      },
      {
        title: "监控视频平台",
        icon: require("../assets/menu-icon/vdo.svg"),
        show: true,
        platform: "iot",
        menu: [
          {
            menuName: "视频",
            menuUrl: "vdo",
            code: "iotclouds",
            show: true
          }
        ]
      },
      {
        title: "RPA",
        icon: require("../assets/menu-icon/rpa.svg"),
        show: true,
        menu: [
          {
            menuName: "RPA管理",
            menuUrl: "/designer/",
            code: "rpa",
            show: true,
            type: "rpa"
          },
          {
            menuName: "运营中心",
            menuUrl: "/designer/#/dzh",
            code: "rpa",
            show: true,
            type: "rpa"
          }
        ]
      }
    ]
  }
};
export default data;



// WEBPACK FOOTER //
// ./src/common/menuList.js